module.exports = __webpack_public_path__ + "img/4.8f738d95.png";